import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL, TOKEN, URL } from "./constant";


export const api = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem(TOKEN);
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            headers.set("Accept", "application/json");
            return headers;
        },
    }),

    refetchOnMountOrArgChange: true,
    tagTypes: ["ProductList"],
    endpoints: (builder) => ({
        // POST API -> Send OTP
        sendOtp: builder.mutation({
            query: (payload) => ({
                url: URL.login,
                method: "POST",
                body: payload,
            }),
        }),
        // POST API -> Verify OTP
        verifyOtp: builder.mutation({
            query: ({ phone, otp }) => ({
                url: URL.verify,
                method: "POST",
                body: { phone, otp },
            }),
        }),
        resendotp: builder.mutation({
            query: ({ phone, otp }) => ({
                url: URL.resendotp,
                method: "POST",
                body: { phone, otp },
            }),

        }),

        registerOtp: builder.mutation({
            query: (payload) => ({
                url: URL.register,
                method: "POST",
                body: payload,
            }),
        }),

        viewProducts: builder.query({
            query: () => ({
                url: URL.PRODUCT_LIST,
                method: 'GET',
            }),
            providesTags: ['PRODUCTVIEW'],
        }),


        searchproducts: builder.query({
            query: (searchTerm) => ({
              url: `${URL.SEARCH}?key=${encodeURIComponent(searchTerm)}`,
              method: 'GET',
            }),
            providesTags: ['PRODUCTVIEW'],
          }),
          
          
        // updateCartItem: builder.mutation({
        //     query: ({ cartItemId, quantity }) => ({
        //       url: `/cart/${cartItemId}`,
        //       method: "PUT",
        //       body: { quantity },
        //     }),
        //   }),

        popular: builder.query({
            query: () => ({
                url: URL.POPULAR_PRODUCT,
                method: 'GET',
            })
        }),

        categorylist: builder.query({
            query: () => ({
                url: URL.CATEGORY_LIST,
                method: 'GET',
            }),
        }),

        addToCart: builder.mutation({
            query: ({ productId, userId, quantity }) => ({
                url: URL.cart,
                method: 'POST',
                body: { productId, userId, quantity },
            }),
        }),

        addToCartupdate: builder.mutation({
            query: (payload) => ({
                url: URL.cart,
                method: 'POST',
                body: payload,
            }),
        }),

        deleteFromCart: builder.mutation({
            query: (itemId) => ({
                url: `/cart/${itemId}`,
                method: 'DELETE',
            }),
        }),

        cartView: builder.query({
            query: (userId) => ({
                url: `${URL.cartview}/${userId}`,
                method: "GET",
            }),
            providesTags: ["Cart"],
        }),

        logout: builder.mutation({
            query: () => ({
                url: URL.logout,
                method: 'POST',
            }),
        }),

        whishlist: builder.mutation({
            query: (data) => ({
                url: "/whishlist/add",
                method: "POST",
                body: data,
            }),
        }),
        viewWishlist: builder.query({
            query: ({ userId }) => ({
                url: `${URL.viewishlist}/${userId}`,
                method: "GET",
            }),
        }),
        Address: builder.mutation({
            query: (data) => ({
                url: URL.Address,
                method: "POST",
                body: data,
            }),
        }),
        viewAddress: builder.query({
            query: (userId) => ({
                url: `${URL.ViewAddress}/${userId}`,  
                method: "GET",
            }),
        }),
        EditAddress: builder.mutation({
            query: ({ payload, id }) => ({
                url: `${URL.EditAddress}${id}`,
                method: "PUT",
                body: payload
            }),
        }),

        updatecart: builder.mutation({
            query: ({ itemId }) => ({
                url: `${URL}/${itemId}`,
                method: "POST",
            }),
        }),


        getTopsellproduct: builder.query({
            query: (data) => ({
                url: `${URL.GetTopsell}`,
                method: "GET",
                body: data
            })
        }),
        orderpost: builder.mutation({
            query: (data) => ({
                url: `${URL.orderpost}`,
                method: "POST",
                body: { data }
            })
        }),
        orderconfirm: builder.mutation({
            query: (data) => ({
                url: URL.orderconfirm,
                method: "POST",
                body: data
            })
        }),

        orderget: builder.query({
            query: (userId) => ({
                url: `${URL.orderget}/${userId}`,
                method: "GET",
            }),
        }),

        orderallget: builder.query({
            query: (userId) => ({
                url: `${URL.getallorder}?userId=${userId}`, 
                method: "GET",
            }),
        }),


        popularviewsep: builder.query({
            query: (id) => ({
                url: `${URL.viewpopular}/${id}`,
                method: "GET",
            }),
        }),

        profilepage: builder.mutation({
            query: (payload) => ({
                url: `${URL.Personalprofile}`,
                method: "POST",
                body: payload
            })
        }),

        profileget: builder.query({
            query: (userId) => ({
                url: `${URL.Personalget}/${userId}`,
                method: "GET",
            }),
        }),

        profileedit: builder.mutation({
            query: ({ id, payload }) => ({
                url: `${URL.profileedit}/${id}`,
                method: "POST",
                body: payload,
            }),
        }),

        profiledelete: builder.mutation({
            query: ({ id }) => ({
                url: `${URL.profiledelete}/${id}`,
                method: "POST",

            })
        }),

        cancelorders: builder.query({
            query: (id) => ({
                url: `${URL.cancelorder}/${id}`,
                method: "DELETE",
            }),
        }),
        removewishlist: builder.query({
            query: ({ userId, productId }) => ({
                url: `${URL.removewishlist}/${userId}/${productId}`,
                method: "GET",
            })
        }),
    }),
});

export const {
    useSendOtpMutation,
    useVerifyOtpMutation,
    useRegisterOtpMutation,
    useLazyViewProductsQuery,
    useLazyCategorylistQuery,
    useAddToCartMutation,
    useLazyCartViewQuery,
    useLogoutMutation,
    useDeleteFromCartMutation,
    useWhishlistMutation,
    useResendotpMutation,
    useLazyViewWishlistQuery,
    useLazyRemovewishlistQuery,
    useAddressMutation,
    useLazyViewAddressQuery,
    useEditAddressMutation,
    useLazyGetTopsellproductQuery,
    // useUpdateCartItemMutation ,
    useOrderpostMutation,
    useProfilepageMutation,
    useProfileeditMutation,
    useLazyProfilegetQuery,
    useProfiledeleteMutation,
    useOrderconfirmMutation,
    useLazyPopularviewsepQuery,
    useUpdatecartMutation,
    useAddToCartupdateMutation,
    useLazyOrdergetQuery,
    useLazyOrderallgetQuery,
    useLazySearchproductsQuery,
    useLazyCancelordersQuery,


} = api;
